import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@context/AuthContext';
import LoginPage from '@components/LoginPage.jsx';
import ResetPasswordPage from '@components/ResetPasswordPage.jsx';
import ChangePasswordPage from '@components/ChangePasswordPage.jsx';
import MFAVerificationPage from '@components/MFAVerificationPage.jsx';
import SsoCallbackPage from '@components/SsoCallbackPage.jsx';
import Dashboard from '@components/Dashboard';
import { RefreshCw } from 'lucide-react';

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <AuthWrapper />
            </AuthProvider>
        </BrowserRouter>
    );
}

function AuthWrapper() {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center">
                    <RefreshCw className="w-10 h-10 text-blue-600 animate-spin mx-auto mb-4" />
                    <p className="text-gray-600">Loading...</p>
                </div>
            </div>
        );
    }

    // Public routes (+ unprotected auth flow pages)
    if (!user) {
        return (
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/change-password" element={<ChangePasswordPage />} />
                <Route path="/mfa-verify" element={<MFAVerificationPage />} />
                <Route path="/sso/callback" element={<SsoCallbackPage />} />
                <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
        );
    }

    // Protected routes
    return <Dashboard />;
}

export default App;
